import type { JSX } from 'react';
import React, { useEffect } from 'react';

import { Spinner } from '@feathr/components';

import { useStripeOnboardingRedirect } from './hooks/useStripeOnboardingRedirect';

/**
 * Route component that automatically fetches a new Stripe onboarding URL and redirects to it.
 * This handles the edge case where a one-time Stripe setup link has expired and the user
 * needs a fresh link to complete their setup.
 */
function StripeOnboardingRedirect(): JSX.Element {
  const { redirectToStripeOnboarding } = useStripeOnboardingRedirect();

  useEffect(() => {
    redirectToStripeOnboarding();
  }, [redirectToStripeOnboarding]);

  return <Spinner />;
}

export default StripeOnboardingRedirect;
